import styled from "styled-components";

export const StyledLogsWrapper = styled.div`
  position: relative;
  .logs-head {
    padding: 60px 0 30px;
    display: grid;
    grid-template-columns: max-content 175px;
    grid-gap: 20px;
    @media screen and (max-width: 576px) {
      grid-template-columns: 100%;
    }
  }
  .logs-table_scroll {
    @media screen and (max-width: 992px) {
      overflow: inherit;
    }
  }
  
  .logs-table {
    &__head-system, &__row-system {
      grid-template-columns: 170px 300px 150px minmax(250px, 1fr) 100px 200px;
    }
    &__head-service, &__row-service {
      grid-template-columns: 170px repeat(2, minmax(250px, .85fr)) 150px minmax(250px, 1fr) 100px 200px;
    }
    &__event {
      position: relative;
    }
    .read-more {
      padding: 3px 7px;
      border-radius: 25px;
      color: #fff;
      font-size: 12px;
      font-weight: 600;
      display: none;
      background-color: #277661;
      border: none;
      outline: none;
      position: absolute;
      bottom: 0;
      right: 5px;
    }
    .read-more_is-overflow {
      display: block;
    }
    .read-more_active {
      bottom: -23px;
    }
    
    @media screen and (max-width: 992px) {
      min-width: auto;
      overflow-x: inherit;
      &__head-system,
      &__head-service {
        display: none;
      }
      &__row-system,
      &__row-service {
        margin-bottom: 15px;
        grid-template-columns: repeat(2, 1fr);
        border: 1px solid #E5E5E5;
        & > div {
          padding-top: 20px;
          &:before {
            display: block;
          }
        }
      }
      
      &__event {
        grid-column-start: 1;
        grid-column-end: 3;
      }
    }

    @media screen and (max-width: 599px) {
      &__row {
        padding: 15px 10px;
        grid-template-columns: 100%;
      }
      &__event {
        grid-column-end: 1;
      }
    }
  }
`;

export const StyledEventLogs = styled.div`
  max-height: ${({show}) => show ? 'inherit;' : '70px'};
  overflow: hidden;
  transition: all .3s ease;
  p {
    text-align: left;
  }
`;